
    import { find } from 'lodash';
    import { Endereco } from '@/models/endereco_model';
    import { ESTADOS as estados, BACEN_BRASIL, TIPOS_ENDERECO, TIPOS_ENDERECO_ARRAY } from '@/constants';
    import customEvents from '@/services/custom_events';
    import enderecoStore from '@/stores/endereco_store';
    import IPais from '@/interfaces/pais.interface';
    import ICidade from '@/interfaces/cidade.interface';
    import ErrosBackend from '../../libs/comum/helpers/comum_error_parse';
    import ListaEnderecos from '@/components/endereco/ListaEnderecos.vue';
    import CepService from '@/libs/comum/services/comum_service_cep_service';
    import PaisService from '@/services/pais_service'
    import MunicipioService from '@/libs/comum/services/comum_service_municipio_service';

    export default {
        name: 'EnderecoComponent',
        components: {
            ListaEnderecos
        },
        data: () => ({
            paises: [] as IPais[],
            cidades: [] as ICidade[],
            cidade: {
                codigoMunicipio: '',
                municipio: ''
            },
            indexEnderecoSelecionado: -1,
            carregandoEndereco: false,
            tipoEnderecoCadastrado: false,
            temTodosTiposEndereco: false,
            editMode: false,
            showMore: false
        }),
        computed: {
            endereco() {
                return enderecoStore.state.endereco;
            },
            enderecos() {
                return enderecoStore.state.enderecos;
            },
            tiposEndereco() {
                return TIPOS_ENDERECO_ARRAY;
            },
            estados() {
                if (this.endereco.identificacao?.codigo !== TIPOS_ENDERECO.PRINCIPAL.codigo) {
                    return estados.filter((e) => e.sigla !== 'EX');
                }

                return estados;
            }
        },
        methods: {
            scrollToList(goTop = false, htmlElement?: HTMLElement) {
                const element = htmlElement ?? this.$el;
                this.$nextTick(() => {
                    if (element) element.scrollTop = goTop ? 0 : element.scrollHeight;
                });
            },
            setComportamentoFormulario(value: boolean) {
                this.showMore = value;
                this.editMode = value;
            },
            limparEnderecoPreenchido() {
                this.indexEnderecoSelecionado = -1;
                this.tipoEnderecoCadastrado = false;

                this.limparCidade();
                enderecoStore.dispatch('setEndereco', new Endereco());
                enderecoStore.dispatch('setManutencaoIniciada', this.showMore);
                enderecoStore.dispatch('setEnderecoInvalido', false);
            },
            adicionarNovoEndereco() {
                this.showMore = !this.showMore;
                enderecoStore.dispatch('setManutencaoIniciada', this.showMore);

                if (!this.enderecos.some((endereco) => endereco.principal === true)) {
                    this.endereco.identificacao = TIPOS_ENDERECO.PRINCIPAL;
                }

                const element = document.getElementById('koopon-modal-pessoa-especifica');

                if (element) {
                    this.scrollToList(false, element);
                }
            },
            editarEndereco(endereco: Endereco, index: number) {
                this.indexEnderecoSelecionado = index;

                this.setComportamentoFormulario(true);
                this.scrollToList(true);
                enderecoStore.dispatch('setEndereco', endereco);
                enderecoStore.dispatch('setManutencaoIniciada', this.showMore);
            },
            validarEndereco() {
                if (this.validarTipoEnderecoCadastrado()) {
                    this.tipoEnderecoCadastrado = true;
                    return false;
                }

                if (!this.endereco.validarEndereco()) {
                    return false;
                }

                return true;
            },
            gravarManutencaoEndereco() {
                const isEnderecoValido = this.validarEndereco();
                enderecoStore.dispatch('setEnderecoInvalido', !isEnderecoValido);

                if (!isEnderecoValido) return;

                if (this.editMode)
                    enderecoStore.dispatch('atualizarEndereco', this.indexEnderecoSelecionado);
                else
                    this.enderecos.push(new Endereco(this.endereco));

                enderecoStore.dispatch('ordenar');
                this.fecharManutencaoEndereco();
                this.scrollToList();
            },
            excluirEndereco(endereco: Endereco, index: number) {
                enderecoStore.dispatch('setEndereco', endereco);
                enderecoStore.dispatch('excluirEndereco', index);

                this.setComportamentoFormulario(false);
                this.limparEnderecoPreenchido();
            },
            fecharManutencaoEndereco() {
                enderecoStore.dispatch('setEnderecoInvalido', false);
                this.setComportamentoFormulario(false);
                this.limparEnderecoPreenchido();
            },
            validarTipoEnderecoCadastrado() {
                if (this.editMode) {
                    const tipoEnderecoOrigem = this.enderecos[this.indexEnderecoSelecionado]?.identificacao;

                    if (this.endereco.identificacao?.codigo === tipoEnderecoOrigem.codigo) return false;
                }

                return this.enderecos.some(
                    (endereco) => endereco.identificacao.codigo === this.endereco.identificacao?.codigo
                );
            },
            verificarTodosTiposEnderecoCadastrados() {
                this.temTodosTiposEndereco = this.tiposEndereco.length === this.enderecos.length;
            },
            onSelectTipoEndereco() {
                this.tipoEnderecoCadastrado = false;
                this.endereco.removerPendencia('identificacao');
                
                if(this.endereco.identificacao?.codigo !== TIPOS_ENDERECO.PRINCIPAL.codigo && this.endereco?.estado?.sigla === 'EX') {
                    this.endereco.limparEstado();
                }
            },
            obterPorCep(onChange = false) {
                let cep = this.endereco.cep;

                if (!cep) {
                    this.carregandoEndereco = false;
                    return;
                }

                cep = cep.replace(/\D/g, '');

                this.endereco.limparPendencias();

                if ((!!onChange && cep.length === 8) || (!onChange)) {
                    this.carregandoEndereco = true;
                    customEvents.exibeCarregando();

                    CepService.obterPorCep(cep)
                    .then((info) => {
                        this.endereco.estende(info);
                        this.obterMunicipiosDoEstado(info.estado.sigla, info.codigoMunicipioIBGE);
                    })
                    .catch((error) => {
                        this.endereco.cep = cep;
                        customEvents.exibeAlerta({msg:ErrosBackend.parseErrors(error) || "Houve um problema ao buscar o CEP"});
                        customEvents.escondeCarregando();
                    })
                    .finally(() => {
                        this.carregandoEndereco = false;
                        customEvents.escondeCarregando();
                    });
                }
            },

            async obterPaises() {
                if (this.paises.length > 0 || this.endereco?.estado?.sigla !== 'EX') {
                    return;
                }

                try {
                    const dados = await PaisService.obterPaises();
                    
                    this.paises = dados ?? [];
                }
                catch(error) {
                    this.paises = [];
                }
            },

            obterMunicipiosDoEstado(uf:string, codigo?:string) {
                MunicipioService.obterMunicipios(uf)
                .then((municipios) => {
                    this.cidades = [...municipios];

                    if (uf === 'EX') {
                        this.cidade = this.cidades?.[0];
                        this.enderecoMunicipioAtualizado();
                    }
                })
                .catch(() => {
                    this.cidades = [];
                })
                .finally(() => {
                    if (codigo) {
                        this.cidade = find(this.cidades, {codigoMunicipio: codigo});
                    }
                });
            },

            atualizaCodigoPaisBacen(uf:string) {
                if (uf === 'EX') {
                    this.endereco.codigoPaisBacen = undefined;
                    return;
                }
                this.endereco.codigoPaisBacen = BACEN_BRASIL;
            },

            enderecoUfAtualizado() {
                this.limparCidade();
                this.limparPais();
                this.obterMunicipiosDoEstado(this.endereco.estado.sigla);
                this.obterPaises();
                this.atualizaCodigoPaisBacen(this.endereco.estado.sigla);


                if (this.endereco.isEstadoExterior()) {
                    this.endereco.removerPendencia('bairro');
                    this.endereco.removerPendencia('cidade');
                    this.endereco.removerPendencia('codigoPaisBacen');
                    this.endereco.cep = undefined;
                }
            },

            enderecoMunicipioAtualizado() {
                this.endereco.cidade = this.cidade ? this.cidade.municipio : undefined;
                this.endereco.codigoMunicipioIBGE = this.cidade ? this.cidade.codigoMunicipio : undefined;

                const pais = this.paises.find((p) => p.codigo === this.endereco.codigoPaisBacen);

                this.endereco.pais = pais ? pais.nome : undefined;
            },

            enderecoPaisAtualizado() {
                const pais = this.paises.find((p) => p.codigo === this.endereco.codigoPaisBacen);

                this.endereco.pais = pais ? pais.nome : undefined;
            },

            limparCidade() {
                this.cidade = {codigoMunicipio: '', municipio: ''};
                this.endereco.cidade = undefined;
                this.endereco.codigoMunicipioIBGE = undefined;
            },

            limparPais() {
                this.endereco.pais = undefined;
            },

            getCustomLabelPaises(opt: string) {
                const selectOption = this.paises.find(
                 (p) => p.codigo === opt
                );

                return selectOption ? selectOption.nome : '';
            },
        },
        watch: {
            endereco: async function() {
                this.obterMunicipiosDoEstado(this.endereco.estado.sigla, this.endereco.codigoMunicipioIBGE);
                await this.obterPaises();
            },
            enderecos: function() {
                this.verificarTodosTiposEnderecoCadastrados();
            }
        },
        beforeDestroy() {
            enderecoStore.dispatch('limparEnderecoStore');
        },
    };
